import { Table } from 'antd';
import type {
  MaintenanceContractIssue,
  MaintenanceSlaDraftLevel,
} from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';
import { withLevelTimer } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/utils';
import { useMaintenanceSlaTimerColumns } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/hooks/useMaintenanceSlaTimerColumns';

export interface MaintenanceSlaTimerEditorProps {
  level: MaintenanceSlaDraftLevel;
  issues: readonly MaintenanceContractIssue[];
  onChange: (level: MaintenanceSlaDraftLevel) => void;
}

export function MaintenanceSlaTimerEditor({
  level,
  issues,
  onChange,
}: MaintenanceSlaTimerEditorProps) {
  const columns = useMaintenanceSlaTimerColumns({
    levelCode: level.code,
    issues,
    onTimerChange: (kind, patch) =>
      onChange(withLevelTimer(level, kind, patch)),
  });

  return (
    <Table
      size="small"
      pagination={false}
      scroll={{ x: 980 }}
      rowKey="kind"
      dataSource={level.timers}
      columns={columns}
    />
  );
}
